import Dropzone from 'dropzone/dist/min/dropzone.min.js';

Dropzone.options.usersenseDocuments = {
    acceptedFiles: 'application/pdf',
    createImageThumbnails: false,
    previewTemplate: $("#preview-template").html()
}
